import { render } from "./education-input.vue?vue&type=template&id=1aa95c8e&ts=true"
import script from "./education-input.vue?vue&type=script&lang=ts"
export * from "./education-input.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__